import ReadOnly from './ReadOnlyContainer'

export default ReadOnly
